import { getNextDate, getPreviousDate } from "@ui-seeker/utils"
import { legacyColors } from "@palette"


export const DATE_PERIODS = {
	YESTERDAY: 'yesterday',
	LAST_7_DAYS: 'last7days',
	LAST_14_DAYS: 'last14Days',
	LAST_30_DAYS: 'last30Days',
	LAST_60_DAYS: 'last60Days',
	LAST_90_DAYS: 'last90Days',
	LAST_MONTH: 'lastMonth',
	LAST_3_MONTHS: 'last3Months',
	LAST_QUARTER: 'lastQuarter',
	LAST_YEAR: 'lastYear',
	YEAR_TO_DATE: 'yearToDate',
	MONTH_TO_DATE: 'monthToDate',
	CUSTOM: 'custom'
}

export const PREVIOUS_PERIODS = {
	[DATE_PERIODS.YESTERDAY]: [getPreviousDate({ days: 2 }), getPreviousDate({ days: 2 })],
	[DATE_PERIODS.LAST_7_DAYS]: [getPreviousDate({ days: 14 }), getPreviousDate({ days: 8 })],
	[DATE_PERIODS.LAST_30_DAYS]: [getPreviousDate({ days: 60 }), getPreviousDate({ days: 31 })],
	[DATE_PERIODS.LAST_60_DAYS]: [getPreviousDate({ days: 120 }), getPreviousDate({ days: 61 })],
	[DATE_PERIODS.LAST_90_DAYS]: [getPreviousDate({ days: 180 }), getPreviousDate({ days: 91 })],
}

export const DATE_PRESETS = [
	{
		label: 'Yesterday',
		value: [getPreviousDate({ days: 1 }), getPreviousDate({ days: 1 })],
		placement: 'left',
		color: legacyColors.cssBlue
	}, {
		label: 'Last 7 Days',
		value: [getPreviousDate({ weeks: 1 }), getPreviousDate({ weeks: 0 })],
		placement: 'left',
		color: legacyColors.cssBlue
	}, {
		label: 'Last 14 Days',
		value: [getPreviousDate({ weeks: 2 }), getPreviousDate({ days: 0 })],
		placement: 'left',
		color: legacyColors.cssBlue
	}, {
		label: 'Last 30 Days',
		value: [getPreviousDate({ days: 30 }), getPreviousDate({ days: 0 })],
		placement: 'left',
		color: legacyColors.cssBlue
	}, {
		label: 'Last 60 Days',
		value: [getPreviousDate({ days: 60 }), getPreviousDate({ days: 0 })],
		placement: 'left',
		color: legacyColors.cssBlue
	}, {
		label: 'Last 90 Days',
		value: [getPreviousDate({ days: 90 }), getPreviousDate({ days: 0 })],
		placement: 'left',
		color: legacyColors.cssBlue
	}, {
		label: 'Last Year',
		value: [getPreviousDate({ years: 2 }), getPreviousDate({ years: 1 })],
		placement: 'left',
		color: legacyColors.cssBlue
	}
]

export const DATE_PRESETS_AFTER = [
	{
		label: 'Tomorrow',
		value: [getNextDate({ days: 1 }), getNextDate({ days: 1 })],
		placement: 'left',
		color: legacyColors.cssBlue
	}, {
		label: 'Next week',
		value: [getNextDate({ weeks: 0 }), getNextDate({ weeks: 1 })],
		placement: 'left',
		color: legacyColors.cssBlue
	}, {
		label: 'Next 2 weeks',
		value: [getNextDate({ weeks: 0 }), getNextDate({ days: 2 })],
		placement: 'left',
		color: legacyColors.cssBlue
	}, {
		label: 'Next month',
		value: [getNextDate({ days: 0 }), getNextDate({ days: 30 })],
		placement: 'left',
		color: legacyColors.cssBlue
	}, {
		label: 'Next 2 months',
		value: [getNextDate({ days: 0 }), getNextDate({ days: 60 })],
		placement: 'left',
		color: legacyColors.cssBlue
	}, {
		label: 'Next 3 months',
		value: [getNextDate({ days: 0 }), getNextDate({ days: 90 })],
		placement: 'left',
		color: legacyColors.cssBlue
	}, {
		label: 'Next year',
		value: [getNextDate({ years: 1 }), getNextDate({ years: 2 })],
		placement: 'left',
		color: legacyColors.cssBlue
	}
]